import { environment } from './environments/environment';

// Keeping warn and error
// Imported first in main.ts so it runs before the application is bootstrapped.
if (environment.production) {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
}
